import { useState, useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import TermsOfServicePage from './TermsOfServicePage'

import { TermDetailModal } from '@/components/auth/Tos/TermDetailModal'
import type { TermKey, TermDetail, Provider } from '@/components/auth/signup/SignupForm'
import { TERM_DETAILS_CONTENT } from '@/components/auth/Tos/termsContent'

export default function TosPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const provider = (searchParams.get('provider') as Provider) || 'kakao'
  const user_id = searchParams.get('user_id') || ''

  const [showTermDetailModal, setShowTermDetailModal] = useState<boolean>(false)
  const [currentTermDetailKey, setCurrentTermDetailKey] = useState<TermKey | null>(null)

  const handleClose = useCallback(() => {
    navigate('/auth/login')
  }, [navigate])

  const handleTermsAgree = useCallback(() => {
    navigate(`/auth/signup?provider=${provider}&privacyConsent=true&user_id=${user_id}`)
  }, [navigate, provider, user_id])

  const handleShowTermDetail = useCallback((termKey: TermKey) => {
    setCurrentTermDetailKey(termKey)
    setShowTermDetailModal(true)
  }, [])

  const termDetailToShow: TermDetail | null = currentTermDetailKey ? TERM_DETAILS_CONTENT[currentTermDetailKey] : null

  return (
    <div className='flex flex-col min-h-screen relative font-sans noto-sans-kr'>
      <TermsOfServicePage
        selectedProvider={provider}
        onClose={handleClose}
        onAgree={handleTermsAgree}
        onShowTermDetail={handleShowTermDetail}
      />

      {currentTermDetailKey && termDetailToShow && (
        <TermDetailModal
          term={termDetailToShow}
          isOpen={showTermDetailModal}
          onClose={() => {
            setShowTermDetailModal(false)
            setCurrentTermDetailKey(null)
          }}
        />
      )}
    </div>
  )
}
